import { Injectable } from '@angular/core';
import { IframeMode } from '../../../enums/iframe-mode.enum';

@Injectable({
  providedIn: 'root'
})
export class IframeModeService {
  private _iframeMode: IframeMode | null = null;

  constructor() {
    this.detectIframeMode();
  }

  private detectIframeMode(): void {
    const urlParams = new URLSearchParams(window.location.search);
    const iframeModeParam = urlParams.get('iframeMode');
    
    if (iframeModeParam === IframeMode.INLINE || iframeModeParam === 'INLINE') {
      this._iframeMode = IframeMode.INLINE;
    } else if (iframeModeParam === IframeMode.WIDGET || iframeModeParam === 'WIDGET') {
      this._iframeMode = IframeMode.WIDGET;
    } else {
      this._iframeMode = IframeMode.NONE;
    }
  }

  getIframeMode(): IframeMode {
    if (this._iframeMode === null) {
      this.detectIframeMode();
    }
    return this._iframeMode!;
  }

  isIframeMode(): boolean {
    const mode = this.getIframeMode();
    return mode === IframeMode.WIDGET || mode === IframeMode.INLINE;
  }

  isInlineMode(): boolean {
    return this.getIframeMode() === IframeMode.INLINE;
  }

  isWidgetMode(): boolean {
    return this.getIframeMode() === IframeMode.WIDGET;
  }

  hasInvalidIframeMode(): boolean {
    if (!this.isInIframe()) return false;
    const mode = this.getIframeMode();
    return mode !== IframeMode.INLINE && mode !== IframeMode.WIDGET;
  }

  sendMessageToParent(action: string, data?: any): void {
    if (this.isIframeMode() && window.parent && window.parent !== window.self) {
      window.parent.postMessage({
        type: 'TITAN_CHATBOT',
        action: action,
        ...data
      }, '*');
    }
  }

  sendMessageToParentIfInIframe(action: string, data?: any): void {
    if (this.isInIframe() && window.parent && window.parent !== window.self) {
      window.parent.postMessage({
        type: 'TITAN_CHATBOT',
        action: action,
        ...data
      }, '*');
    }
  }

  isInIframe(): boolean {
    return window.self !== window.top;
  }
}
